import React from "react";

import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { useAppContext } from "@state/hooks/shared";
import { observer } from "mobx-react";

export default observer(function GamingHistoryTabSwitcher() {
	const { t } = useTranslation();
	const { culture } = useAppContext();

	return (
		<div className="card--primary__tabs">
			<nav className="tabs--primary">
				{WEBPACK_IS_CASINO_ENABLED ? (
					<NavLink
						className="tabs--primary__item"
						activeClassName="is-active"
						replace={true}
						to={`/${culture}/gaming-history/games`}
					>
						{t<string>("specific:GAMING_HISTORY.CASINO")}
					</NavLink>
				) : null}
				{WEBPACK_IS_CASINO_LIVE_ENABLED ? (
					<NavLink
						to={`/${culture}/gaming-history/live-games`}
						className="tabs--primary__item"
						replace={true}
						activeClassName="is-active"
					>
						{t<string>("specific:GAMING_HISTORY.LIVE_CASINO")}
					</NavLink>
				) : null}
			</nav>
		</div>
	);
});
